import React, { forwardRef } from "react"
import { Group, Image, Layer, Line, Rect, Stage } from "react-konva"
import { useImage } from "react-konva-utils"
import Konva from "konva"
import { roundRect } from "../../util/canvas_utils"
import { GraphPropContextProvider, useGraphPropContext } from "../GraphPropsContext"
import { GraphRendererProps } from "../Types"
import BackgroundImage from "./images/Background_EN.png"

export const FMAT_GRID_PAD = 35
const VALUE_MIN = 15
const VALUE_LIMIT = 60

const FMatGrid = ({ show }) => {
  if (!show) return null

  const { l } = useGraphPropContext()
  const center = gridPoints(l, 1)
  const lines = [...gridPoints(l, 2), ...center]
  const dotted = gridPoints(l, 4)

  return (
    <>
      <Group opacity={0.4}>
        {lines.map((line) => (
          <Line points={line} stroke="black" strokeWidth={1} />
        ))}
      </Group>
      <Group opacity={0.4}>
        {dotted.map((line) => (
          <Line points={line} stroke="black" strokeWidth={1} dash={[2, 2]} />
        ))}
      </Group>
    </>
  )
}

const gridPoints = (l: number, count: number) => {
  const points = []
  const interval = l / count
  const start = interval / 2
  let flip = false
  for (let i = 0; i < 2; i++) {
    for (let j = 0; j < count; j++) {
      const pos = start + interval * j
      if (!flip) {
        points.push([pos, 0, pos, l])
      } else {
        points.push([0, pos, l, pos])
      }
    }
    flip = true
  }
  return points
}

export const FMatQuadrantRenderer = forwardRef<Konva.Stage, GraphRendererProps>((props, ref) => {
  const { width, children, showGrid } = props
  const [image] = useImage(BackgroundImage)
  const pad = 29
  const innerWidth = width - pad * 2

  return (
    <Stage width={width} height={width} ref={ref}>
      <GraphPropContextProvider width={innerWidth} pmin={VALUE_MIN} pmax={VALUE_LIMIT}>
        <Layer
          clipFunc={(ctx) => {
            roundRect(ctx, 0, 0, width, width, 15, false, false)
          }}
        >
          {!showGrid ? (
            <Image image={image} width={width} height={width} />
          ) : (
            <Rect x={pad} y={pad} width={innerWidth} height={innerWidth} fill="white" cornerRadius={15} />
          )}
          <Group x={pad} y={pad}>
            <FMatGrid show={showGrid} />
          </Group>
        </Layer>
        <Layer x={pad} y={pad} width={innerWidth} height={innerWidth}>
          {children}
        </Layer>
      </GraphPropContextProvider>
    </Stage>
  )
})
